const quotationChat = {
  quotationChatNavLabel: "Συνομιλία προσφοράς", // translated 
  quotationChatApprovalTitle: "Συνομιλία προσφοράς", // translated 
  quotationChatAccountNotApprovedTitle: "Ο λογαριασμός δεν έχει εγκριθεί", // translated 
  quotationChatAccountNotApprovedDescription:
    "Ο λογαριασμός σας δεν έχει εγκριθεί ακόμα. Επικοινωνήστε με τον υπεύθυνο λογαριασμό σας για περισσότερες πληροφορίες.", // translated 
  quotationChatViewAiChat: "Προβολή συνομιλίας Τ.Ν.", // translated 

  quotationRequestChatSessions: "Συνεδρίες συνομιλίας", // translated 
  quotationRequestChatNoPastSessions: "Δεν υπάρχουν προηγούμενες συνεδρίες", // translated 
  quotationRequestChatNewChat: "Νέα συνομιλία", // translated 
  quotationRequestChatCloseSidebar: "Κλείσιμο πλευρικής γραμμής", // translated 
  quotationRequestChatSessionFallback: "Συνεδρία συνομιλίας", // translated 
  quotationRequestChatDefaultSessionName: "Νέα συνεδρία συνομιλίας", // translated 
  quotationRequestChatTitle: "Συνομιλία αιτήματος προσφοράς", // translated 
  quotationRequestChatResponseLanguageLabel: "Γλώσσα απάντησης", // translated 
  quotationRequestChatOpenSidebar: "Άνοιγμα πλευρικής γραμμής", // translated 
  quotationRequestChatRenameSession: "Μετονομασία συνεδρίας", // translated 
  quotationRequestChatDeleteSession: "Διαγραφή συνεδρίας", // translated 
  quotationRequestChatToggleDarkMode: "Εναλλαγή σκοτεινής λειτουργίας", // translated 
  quotationRequestChatSwitchToLightMode: "Μετάβαση σε φωτεινή λειτουργία", // translated 
  quotationRequestChatSwitchToDarkMode: "Μετάβαση σε σκοτεινή λειτουργία", // translated 
  quotationRequestChatEmptyStateHeading: "Ξεκινήστε μια νέα συνομιλία αιτήματος προσφοράς", // translated 
  quotationRequestChatEmptyStateSubheading:
    "Περιγράψτε τις ταξιδιωτικές σας ανάγκες και θα δημιουργήσετε μια αίτηση για εσάς.", // translated 
  quotationRequestChatMessagePlaceholderStart:
    "Πληκτρολογήστε το μήνυμά σας για να ξεκινήσετε μια συνομιλία... (Shift+Enter για νέα γραμμή)", // translated 
  quotationRequestChatMessagePlaceholder: "Πληκτρολογήστε το μήνυμά σας... (Shift+Enter για νέα γραμμή)", // translated 
  quotationRequestChatUploadFile: "Μεταφόρτωση αρχείου", // translated 
  quotationRequestChatUploadAttachment: "Μεταφόρτωση συνημμένου", // translated 

  quotationRequestChatStopGenerating: "Διακοπή δημιουργίας", // translated 
  quotationRequestChatGenerateQuotation: "Δημιουργία προσφοράς", // translated 
  quotationRequestChatGenerateFinalQuotation: "Δημιουργία τελικής προσφοράς", // translated 
  quotationRequestChatFinalizeQuotationRequest: "Οριστικοποίηση αιτήματος προσφοράς", // translated 
  quotationRequestChatHoldToRecord: "Κρατήστε πατημένο για ηχογράφηση φωνητικού μηνύματος", // translated 
  quotationRequestChatRecordingReleaseToSend: "Ηχογράφηση, αφήστε για αποστολή", // translated 
  quotationRequestChatRecording: "Ηχογράφηση...", // translated 
  quotationRequestChatSelectSessionFirst: "Επιλέξτε πρώτα μια συνεδρία συνομιλίας.", // translated 
  quotationRequestChatCancelVoiceRecording: "Ακύρωση ηχογράφησης φωνής", // translated 
  quotationRequestChatListening: "Ακρόαση...", // translated 
  quotationRequestChatTranscribing: "Μεταγραφή...", // translated 

  quotationRequestChatFileUploadedSuccess: "Το αρχείο μεταφορτώθηκε με επιτυχία.", // translated 
  quotationRequestChatUnsupportedFileType: "Μη υποστηριζόμενος τύπος αρχείου. Ανεβάστε PDF, Word (.docx), Excel (.xlsx), PowerPoint (.pptx), κείμενο/CSV ή εικόνα.", // translated
  quotationRequestChatFailedCreateSession: "Αποτυχία δημιουργίας συνεδρίας συνομιλίας. Δοκιμάστε ξανά.", // translated 
  quotationRequestChatFailedUploadFile: "Αποτυχία μεταφόρτωσης αρχείου. Δοκιμάστε ξανά.", // translated 
  quotationRequestChatAnswerPendingBeforeMessage:
    "Απαντήστε πρώτα στις εκκρεμείς ερωτήσεις πριν στείλετε άλλο μήνυμα.", // translated 
  quotationRequestChatAnswerPendingBeforeFinalize:
    "Απαντήστε πρώτα στις εκκρεμείς ερωτήσεις πριν οριστικοποιήσετε την αίτηση προσφοράς.", // translated 
  quotationRequestChatFavoriteMarked: "Η συνεδρία συνομιλίας σημειώθηκε ως αγαπημένη", // translated 
  quotationRequestChatFavoriteUnmarked: "Η συνεδρία συνομιλίας αφαιρέθηκε από τα αγαπημένα", // translated 
  quotationRequestChatFailedSetFavorite: "Αποτυχία ορισμού ως αγαπημένος", // translated 
  quotationRequestChatFailedUnsetFavorite: "Αποτυχία αφαίρεσης από τα αγαπημένα", // translated 
  quotationRequestChatRenamedSuccess: "Η συνεδρία συνομιλίας μετονομάστηκε με επιτυχία.", // translated 
  quotationRequestChatFailedRename: "Αποτυχία μετονομασίας συνεδρίας συνομιλίας. Δοκιμάστε ξανά.", // translated 
  quotationRequestChatDeletedSuccess: "Η συνεδρία συνομιλίας διαγράφηκε με επιτυχία.", // translated 
  quotationRequestChatFailedDelete: "Αποτυχία διαγραφής συνεδρίας συνομιλίας. Δοκιμάστε ξανά.", // translated 
  quotationRequestChatAttachmentDeletedSuccess: "Το συνημμένο διαγράφτηκε με επιτυχία.", // translated 
  quotationRequestChatFailedDeleteAttachment: "Αποτυχία διαγραφής συνημμένου. Δοκιμάστε ξανά.", // translated 
  quotationRequestChatSubmittedSuccess:
    "Η αίτηση προσφοράς υποβλήθηκε με επιτυχία! Το αίτημά σας επεξεργάζεται.", // translated 
  quotationRequestChatFailedSubmit: "Αποτυχία υποβολής αιτήματος προσφοράς", // translated 
  quotationChatPdfDownloadedSuccess: "Το PDF λήφθηκε με επιτυχία!", // translated 
  quotationChatFailedGeneratePdf: "Αποτυχία δημιουργίας PDF", // translated 

  quotationRequestChatSubagentRequired:
    "Επιλέξτε τον χρήστη υπο-πράκτορα πριν υποβάλετε την αίτηση προσφοράς.", // translated 
  quotationRequestChatAppUserLoading:
    "Το προφίλ χρήστη CRM σας φορτώνεται ακόμα. Δοκιμάστε ξανά σε λίγο.", // translated 
  quotationRequestChatAppUserMismatch:
    "Το προφίλ χρήστη CRM σας δεν ταιριάζει με αυτή τη συνεδρία συνομιλίας.", // translated 

  quotationRequestChatRenameTitle: "Μετονομασία συνεδρίας συνομιλίας", // translated 
  quotationRequestChatSessionName: "Όνομα συνεδρίας", // translated 
  quotationRequestChatEnterSessionName: "Εισαγάγετε όνομα συνεδρίας", // translated 
  quotationRequestChatSaving: "Αποθήκευση...", // translated 
  quotationRequestChatSave: "Αποθήκη", // translated 
  quotationRequestChatDeleteTitle: "Διαγραφή συνεδρίας συνομιλίας", // translated 
  quotationRequestChatDeleteConfirm: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή τη συνεδρία συνομιλίας;", // translated 
  quotationRequestChatDeleteCannotUndo: "Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.", // translated 
  quotationRequestChatDeleting: "Διαγραφή...", // translated 
  quotationRequestChatDelete: "Διάγραμμα", // translated 

  quotationRequestChatAttachmentsTitle: "Συνημμένα συνομιλίας αιτήματος προσφοράς", // translated 
  quotationRequestChatLoadingAttachments: "Φόρτωση συνημμένων...", // translated 
  quotationRequestChatNoAttachments: "Δεν βρέθηκαν συνημμένα", // translated 
  quotationRequestChatDeleteAttachment: "Διαγραφή συνημμένου", // translated 
  quotationRequestChatUploadingAttachment: "Μεταφόρτωση συνημμένου...", // translated 
  quotationRequestChatUploadingAttachmentWait: "Περιμένετε όσο μεταφορτώνεται το αρχείο σας.", // translated 

  quotationRequestChatAnswerPendingQuestions: "Απάντηση σε εκκρεμείς ερωτήσεις", // translated 
  quotationRequestChatProposeOwnAnswer: "Προτείνω δική μου απάντηση", // translated 
  quotationRequestChatTypeOwnAnswerPlaceholder: "Πληκτρολογήστε τη δική σας απάντηση...", // translated 
  quotationRequestChatAnsweredOfTotal: "{{απαντήθηκε}} από {{σύνολο}} απαντήθηκαν", // translated 
  quotationRequestChatReadyToSubmit: "Έτοιμο για υποβολή", // translated 
  quotationRequestChatSubmitAll: "Υποβολή όλων", // translated 
  quotationRequestChatRespondToOneQuestion: "Απαντήστε σε {{count}} ερώτηση", // translated 
  quotationRequestChatRespondToManyQuestions: "Απαντήστε σε {{count}} ερωτήσεις", // translated 

  quotationRequestChatFinalizeTitle: "Οριστικοποίηση αιτήματος προσφοράς", // translated 
  quotationRequestChatLoadingSessionData: "Φόρτωση δεδομένων συνεδρίας...", // translated 
  quotationRequestChatErrorLoadingSession: "Σφάλμα φόρτωσης δεδομένων συνεδρίας. Δοκιμάστε ξανά.", // translated 
  quotationRequestChatQuotationTitle: "Τίτλος προσφοράς", // translated 
  quotationRequestChatExtraComments: "Επίπλεον σχόλια", // translated 
  quotationRequestChatSubmitting: "Υποβολή...", // translated 
  quotationRequestChatSubmit: "Υποβολή", // translated 
  quotationRequestChatSubmittingOverlayTitle: "Υποβολή αιτήματος προσφοράς...", // translated 
  quotationRequestChatSubmittingOverlayDescription:
    "Περιμένετε όσο υποβάλλεται η αίτηση προσφοράς σας.", // translated 

  quotationRequestChatSelectSubagent: "Επιλογή υπο-πράκτορα", // translated 
  quotationRequestChatSearchSubagents: "Αναζήτηση υπο-πρακτόρων...", // translated 
  quotationRequestChatLoadingSubagents: "Φόρτωση υπο-πρακτόρων...", // translated 
  quotationRequestChatNoSubagentsFound: "Δεν βρέθηκαν υπο-πράκτορες", // translated 
  quotationRequestChatNoSubagentsAvailable: "Δεν υπάρχουν διαθέσιμες υπο-πράκτορες", // translated 
  quotationRequestChatSelectedSubagent: "Επιλεγμένο: {{label}}", // translated 

  quotationRequestChatSubagentUsers: "Χρήστες υπο-πράκτορα", // translated 
  quotationRequestChatSearchUsers: "Αναζήτηση χρηστών...", // translated 
  quotationRequestChatNoUsersFound: "Δεν βρέθηκαν χρήστες", // translated 
  quotationRequestChatNoUsersAvailable: "Δεν υπάρχουν διαθέσιμοι χρήστες", // translated 

  quotationChatDownloadSummaryTitle: "Λήψη περίληψης προσφοράς", // translated 
  quotationChatDownloadSummaryDescription:
    "Συμπληρώστε τα στοιχεία σας παρακάτω για να δημιουργήσετε εξατομικευμένη περίληψη PDF της προσφοράς ταξιδιού σας. Το PDF θα περιλαμβάνει όλες τις λεπτομέρειες ταξιδιού, προορισμούς, πληροφορίες μεταφοράς και ημερήσιο δρομολόγιο.", // translated 
  quotationChatCustomerTitle: "Τίτλος", // translated 
  quotationChatSelectTitle: "Επιλέξτε τον τίτλο", // translated 
  quotationChatHonorificMr: "Κως.", // translated 
  quotationChatHonorificMrs: "Κα.", // translated 
  quotationChatHonorificMs: "Δις", // translated 
  quotationChatHonorificDr: "Δρ.", // translated 
  quotationChatHonorificProf: "Καθ.", // translated 
  quotationChatCustomerPhone: "Τηλέφωνο", // translated 
  quotationChatCustomerCompany: "Εταιρεία", // translated 
  quotationChatCustomerMessage: "Μήνυμα", // translated 
  quotationChatCustomerCountry: "Χώρα", // translated 
  quotationChatGenerating: "Δημιουργία...", // translated 
  quotationChatDownloadPdf: "Λήψη PDF", // translated 

  quotationChatTripSummary: "Περίληψη ταξιδιού", // translated 
  quotationChatDownloadAsPdf: "Λήψη ως PDF", // translated 
  quotationChatNoTripSummary: "Δεν υπάρχει διαθέσιμη περίληψη ταξιδιού για αυτή τη συνεδρία.", // translated 

  quotationRequestChatThinking: "Σκέφτομαι...", // translated 
  quotationRequestChatSources: "Πηγές", // translated 
  quotationRequestChatSearchingWebFor: 'Αναζήτηση στο διαδίκτυο για: "{{query}}"...', // translated 
  quotationRequestChatServicesByTourOperator: "Υπηρεσίες που εκτελεί ο τουριστικός πράκτορας", // translated 
  quotationRequestChatServicesByCustomer: "Υπηρεσίες που διαχειρίζεται ο πελάτης", // translated 
  quotationRequestChatReadyNotice:
    "Μπορείτε τώρα να δημιουργήσετε προσφορά για αυτό το αίτημα κάνοντας κλικ στο κουμπί στα δεξιά.", // translated 
  quotationRequestChatGenerateFinalQuotationAria: "Δημιουργία τελικής προσφοράς", // translated 

  quotationRequestChatMaybeYouWantToAsk: "Ίσως θέλετε να ρωτήσετε:", // translated 
  quotationRequestChatClickToSendSuggestion: "Κάντε κλικ για αποστολή αυτού του μηνύματος", // translated 

  quotationRequestChatAddToFavorites: "Προσθήκη στα αγαπημένα", // translated 
  quotationRequestChatRemoveFromFavorites: "Αφαίρεση από τα αγαπημένα", // translated 
  quotationRequestChatSubmitted: "Υποβλήθηκε", // translated 

  quotationRequestChatQuotationRequest: "Αίτημα προσφοράς: {{reference}}", // translated 
  quotationRequestChatQuotationTooltipTitle: "{{τίτλος}}", // translated 
  quotationRequestChatQuotationTooltipStatus: " - Κατάσταση: {{κατάσταση}}", // translated 

  quotationChatLoading: "Φόρτωση...", // translated 
  quotationChatSessionNotFound: "Δεν βρέθηκε συνεδρία συνομιλίας για αυτή την προσφορά", // translated 
  quotationChatMemberSessionNotFound: "Δεν βρέθηκε συνεδρία μέλους για τον λογαριασμό σας", // translated 
  quotationChatUnableToConnect: "Αδυναμία σύνδεσης στη συνομιλία", // translated 
  quotationChatConnecting: "Σύνθεση...", // translated 
  quotationChatTypeYourMessage: "πληκτρολογήστε το μήνυμά σας...", // translated 
  quotationChatConnected: "Συνδεδεμένο", // translated 
  quotationChatConnectingStatus: "Σύνθεση...", // translated 
  quotationChatDisconnected: "Αποσυνδεδεμένο", // translated 
};


export default quotationChat;
